@if (multilingualService.langMapObservable | async; as langMap) {
  <section>
    <mat-toolbar class="bg-secondary guest-header">
      <mat-toolbar-row class="justify-content-between">
        <app-logo></app-logo>
        <div class="d-flex ml-auto">
          <div class="filter mr-2">
            <button
              id="select-font-size"
              mat-icon-button
              #menuTrigger="matMenuTrigger"
              [matMenuTriggerFor]="fontSizeMenu"
              [attr.aria-label]="multilingualService?.langMap?.LABEL_SELECT_TEXT"
            >
              <img
                imageName="font-size.svg"
                [common]="true"
                alt="Font Size"
                width="70px"
                class="font-size-image"
              />
            </button>
            <div class="fliter-dropdown">
              <mat-menu #fontSizeMenu="matMenu" class="filter-box guest-text-dropdown">
                <h4
                  (click)="$event.stopPropagation()"
                  class="uppercase d-flex justify-content-between lang-dialog-heading"
                >
                  <span>{{ multilingualService?.langMap?.LABEL_TEXT_SIZE }}</span>
                </h4>
                <div class="filter-form">
                  <mat-radio-group
                    (change)="changeTextSize(multilingualService.selectedTextSize)"
                    [(ngModel)]="multilingualService.selectedTextSize"
                    [attr.aria-label]="multilingualService?.langMap?.LABEL_SELECT_TEXT"
                    class="d-flex flex-column"
                  >
                    <span mat-menu-item>
                      <mat-radio-button value="small">
                        {{ multilingualService?.langMap?.TEXT_SIZE_SMALL }}
                      </mat-radio-button>
                    </span>
                    <span mat-menu-item>
                      <mat-radio-button value="medium">
                        {{ multilingualService?.langMap?.TEXT_SIZE_MEDIUM }}
                      </mat-radio-button>
                    </span>
                    <span mat-menu-item>
                      <mat-radio-button value="large">
                        {{ multilingualService?.langMap?.TEXT_SIZE_LARGE }}
                      </mat-radio-button>
                    </span>
                  </mat-radio-group>
                </div>
              </mat-menu>
            </div>
          </div>
          <div class="filter mr-3">
            <button
              mat-icon-button
              #menuTrigger="matMenuTrigger"
              [matMenuTriggerFor]="menu"
              [attr.aria-label]="multilingualService?.langMap?.SELECT_LANG_LABEL"
            >
              @if (multilingualService?.selectedLang === 'en') {
                <mat-icon class="icon-language-en1"></mat-icon>
              }
              @if (multilingualService?.selectedLang !== 'en') {
                <mat-icon class="icon-language-es1"></mat-icon>
              }
            </button>
            <div class="fliter-dropdown">
              <mat-menu #menu="matMenu" class="filter-box guest-language-dropdown">
                <h4
                  (click)="$event.stopPropagation()"
                  class="uppercase d-flex justify-content-between lang-dialog-heading"
                >
                  <span>{{ multilingualService?.langMap?.SELECT_LANGUAGE }}</span>
                </h4>
                <div class="filter-form">
                  <mat-radio-group
                    (change)="changeLang(selectedLanguage)"
                    [(ngModel)]="selectedLanguage"
                    [attr.aria-label]="multilingualService?.langMap?.SELECT_LANG_LABEL"
                    class="d-flex flex-column"
                  >
                    <span mat-menu-item>
                      <mat-radio-button value="en">
                        {{ multilingualService.langMap?.LABEL_SELECT_LANGUAGE_ENGLISH }}
                      </mat-radio-button>
                    </span>
                    <span mat-menu-item>
                      <mat-radio-button value="es">
                        {{ multilingualService.langMap?.LABEL_SELECT_LANGUAGE_SPANISH }}
                      </mat-radio-button>
                    </span>
                  </mat-radio-group>
                </div>
              </mat-menu>
            </div>
          </div>
          <div class="filter">
            <button class="mr-0" mat-icon-button aria-label="Guest User">
              <mat-icon class="icon-user mr-0"></mat-icon>
            </button>
            <span class="guest-user-text">{{ multilingualService.langMap.LABEL_GUEST_USER }}</span>
          </div>
        </div>
      </mat-toolbar-row>
    </mat-toolbar>
    <section class="carousel-login-box">
      <section class="carousel-box">
        <swiper-container
          class="mySwiper"
          autoplay-delay="3000"
          pagination="true"
          pagination-clickable="true"
          style="--swiper-pagination-color: white"
        >
          <swiper-slide>
            <div class="swiper-text">
              <h1>{{ multilingualService.langMap.LABEL_GUEST_BANNER_HOME }}</h1>
            </div>
            <div class="swiper-img">
              <img imageName="banner-one.svg" alt="" />
            </div>
          </swiper-slide>
          <swiper-slide>
            <div class="swiper-text">
              <h1>
                {{ multilingualService.langMap.LABEL_GUEST_CAROUSEL_BENEFITS_BANNER }}
              </h1>
            </div>
            <div class="swiper-img">
              <img imageName="banner-two.svg" alt="" />
            </div>
          </swiper-slide>
          <swiper-slide>
            <div class="swiper-text">
              <h1>
                {{ multilingualService.langMap.LABEL_GUEST_CAROUSEL_PHARMACY_SEARCH_BANNER }}
              </h1>
            </div>
            <div class="swiper-img">
              <img imageName="banner-three.svg" alt="" />
            </div>
          </swiper-slide>
          <swiper-slide>
            <div class="swiper-text">
              <h1>
                {{ multilingualService.langMap.LABEL_GUEST_CAROUSEL_PRESCRIPTIONS_HISTORY_BANNER }}
              </h1>
            </div>
            <div class="swiper-img">
              <img imageName="banner-four.svg" alt="" />
            </div>
          </swiper-slide>
          <swiper-slide>
            <div class="swiper-text">
              <h1>
                {{ multilingualService.langMap.LABEL_GUEST_CAROUSEL_MAIL_ORDER_BANNER }}
              </h1>
            </div>
            <div class="swiper-img">
              <img imageName="banner-five.svg" alt="" />
            </div>
          </swiper-slide>
          <swiper-slide>
            <div class="swiper-text">
              <h1>
                {{ multilingualService.langMap.LABEL_GUEST_CAROUSEL_DRUG_PRICING_BANNER }}
              </h1>
            </div>
            <div class="swiper-img">
              <img imageName="banner-six.svg" alt="" />
            </div>
          </swiper-slide>
        </swiper-container>
      </section>
      <section class="guest-login-box">
        <h2>
          {{ multilingualService.langMap.LABEL_GUEST_FULL_ACCESS }}
          <!-- Login or create an account for full access to -->
          <strong>{{ multilingualService.langMap.LABEL_GUEST_LOGIN_MESSAGE_SUB_TEXT }}</strong>
        </h2>
        <p>
          {{ multilingualService.langMap.LABEL_GUEST_ACCOUNT_SUB_TEXT }}
          <!-- Already have an
            account? -->
        </p>
        <div>
          <button
            mat-flat-button
            color="primary"
            class="primary-button mat-button-base"
            (click)="goToLogin()"
          >
            {{ multilingualService.langMap.LABEL_GUEST_LOGIN_BUTTON }}
          </button>
        </div>
        <p>
          {{ multilingualService.langMap.LABEL_GUEST_FIRST_TIME }}
          <!-- First time here? -->
        </p>
        <div>
          <button mat-flat-button class="secondary-button" (click)="createAccount()">
            {{ multilingualService.langMap.LABEL_GUEST_CREATE_ACCOUNT_BUTTON }}
          </button>
        </div>
      </section>
    </section>
    <section class="download-faq-support-box">
      <section class="download-faq-box">
        <section class="faq-box">
          <h3>{{ multilingualService.langMap.LABEL_GUEST_FAQS }}</h3>
          <ul class="faqs-list">
            <li
              tabindex="0"
              role="button"
              aria-label="Open FAQ for Benefits"
              (click)="OpenFAQDialog(0, 'BENEFITS FAQ')"
              class="quiz-icon-list"
            >
              <img imageName="icon-faqs.svg" alt="" />
              {{ multilingualService.langMap.LABEL_GUEST_BENEFITS_FAQS }}
            </li>
            <li
              tabindex="0"
              role="button"
              aria-label="Open FAQ for Mail Orders"
              (click)="OpenFAQDialog(1, 'MAIL ORDER FAQ')"
              class="quiz-icon-list"
            >
              <img imageName="icon-faqs.svg" alt="" />
              {{ multilingualService.langMap.LABEL_GUEST_MAIL_ORDER_FAQS }}
            </li>
            <li
              tabindex="0"
              role="button"
              aria-label="Open FAQ for Clinical Reviewss"
              (click)="OpenFAQDialog(2, 'CLINICAL FAQ')"
              class="quiz-icon-list"
            >
              <img imageName="icon-faqs.svg" alt="" />
              {{ multilingualService.langMap.LABEL_GUEST_CLINICAL_FAQS }}
            </li>
          </ul>
        </section>
      </section>
      <section class="customer-support-box">
        <h3>{{ multilingualService.langMap.LABEL_COMMON_CUSTOMER_SUPPORT }}</h3>
        <div class="customer-support-container">
          <div class="customer-support-row">
            <div class="customer-support-icon">
              <img imageName="customer-support-guest.svg" alt="" />
            </div>
            <div class="customer-support-content w-50">
              <p id="label_meber_support" class="customer-support-text">
                {{ multilingualService.langMap.LABEL_COMMON_MEMBER_SERVICES }}
              </p>
              <p
                aria-labelledby="label_meber_support"
                class="member-service-text"
                id="label_meber_support"
              >
                {{ multilingualService.langMap.LABEL_COMMON_MEMBER_SERVICES_VALUE }}
              </p>
            </div>
          </div>
          @if (cmsService.getTechnicalSupportNumber() | async; as technicalSupportNumber) {
            <div class="customer-support-row">
              <div class="customer-support-icon">
                <img imageName="customer-support-guest.svg" alt="" />
              </div>
              <div class="customer-support-content">
                <p id="label_tech_support" class="customer-support-text">
                  {{ multilingualService.langMap.LABEL_COMMON_TECHNICAL_SUPPORT }}
                </p>
                <a
                  aria-labelledby="label_tech_support"
                  class="customer-support-number"
                  href="tel:{{ technicalSupportNumber }}"
                >
                  {{ technicalSupportNumber }}
                </a>
              </div>
            </div>
          } @else {
            <div class="padding-box center loader-circle">
              <img imageName="loader.gif" [common]="true" alt="loader" width="80px" />
            </div>
          }
        </div>
      </section>
    </section>
    <footer>
      <ul>
        <li>
          <a tabindex="0" (click)="OpenPolicyDialog('privacy-policy')">
            {{ multilingualService.langMap.LABEL_BOTTOM_PRIVACY_POLICY }}
          </a>
        </li>
        <li>
          <a tabindex="0" (click)="OpenPolicyDialog('terms-of-use')">
            {{ multilingualService.langMap.LABEL_BOTTOM_TERMS_OF_USE }}
          </a>
        </li>
        @if (aboutUsLink$ | async; as aboutUsLink) {
          <li>
            <a (click)="aboutUsClicked()" [href]="aboutUsLink" target="_blank">
              {{ multilingualService.langMap.LABEL_BOTTOM_ABOUT_US }}
            </a>
          </li>
        }
      </ul>
    </footer>
  </section>
} @else {
  <div class="padding-box center loader-circle">
    <img imageName="loader.gif" [common]="true" alt="loader" width="80px" />
  </div>
}

<ng-template #loader>
  <div class="padding-box center loader-circle">
    <img imageName="loader.gif" [common]="true" alt="loader" width="80px" />
  </div>
</ng-template>

<ng-template #error>
  <div class="toaster-bg error d-flex justify-content-center">
    <mat-icon class="icon-error mr-1"></mat-icon>
    <span role="alert">
      {{ multilingualService.langMap.LABEL_GUEST_ERROR_SORRY }}
    </span>
  </div>
</ng-template>
